import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useStripe, useElements, CardNumberElement } from '@stripe/react-stripe-js';

export default () => {
  const { t } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();

  const createToken = useCallback(
    async ({
      name,
      addressLine1,
      addressLine2,
      addressCity,
      addressState,
      addressCountry,
      addressZip,
    }) => {
      if (!stripe || !elements) {
        throw new Error(t('subscribe.errors.stripe'));
      }

      const cardNumberElement = elements.getElement(CardNumberElement);

      const { error, token } = await stripe.createToken(cardNumberElement, {
        name,
        address_line1: addressLine1,
        address_line2: addressLine2,
        address_city: addressCity,
        address_state: addressState,
        address_country: addressCountry,
        address_zip: addressZip,
      });

      if (error) {
        throw error;
      }

      return token;
    },
    [stripe, elements, t]
  );

  return useMutation(createToken);
};
